import React, {Component} from "react";
import styled from "styled-components";
import {
  ContainWPadding,
  mediaMaxPhone,
  MediumTitle,
  primary,
  Policy,
  SmallMargin,
  dark,
  IconModilect
} from "../Tools/Variables";

const Wrapper = styled.div `
  background: ${dark};
  text-align: center;
  padding: 50px 0;
  font-size: 18px;
  font-weight: 300;
color:${primary};

`;

const today = new Date();

class Footer extends Component {
  render() {
    return (
      <Wrapper>
        <ContainWPadding>

          <div>
            <img
              src={IconModilect}
              alt='Modilect'
              style={{
              height: 33
            }}/>
            <SmallMargin/>
          </div>
          <a href="mailto:info@modilect.com">Info@modilect.com</a>
          <SmallMargin/>
          <a target="_blank" href={Policy}>
            Användarvillkor
          </a>
          <SmallMargin/>
          <a target="_blank" href="/cookies">
            Cookies
          </a>
          <SmallMargin/>
          © Modilect {today.getFullYear()}
          <SmallMargin/>
        </ContainWPadding>
      </Wrapper>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Global/Footer.js